import { Suspense } from 'react'

import ErrorBoundary from '@space-shell/common/components/errorBoundary'
import { lazyWithErrorBoundary } from '@space-shell/common/components/lazyWithErrorBoundary'

import LoaderFull from '@space-shell/common/components/loaderFull'
import { CommunityRouterServer } from '@space-shell/core/router/communityRouter'
import { BASE_PATH, RoutesPaths } from '@space-shell/core/router/constants'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

import RouteGuard from './routeGuard'

import { useClearCache } from '../hooks'

const Home = lazyWithErrorBoundary(() => import('@space-shell/pages/home/server'))
const Products = lazyWithErrorBoundary(() => import('@space-shell/pages/products/server'))
const Gamification = lazyWithErrorBoundary(
  () => import('@space-shell/pages/gamification/gamification')
)
const SalesPage = lazyWithErrorBoundary(() => import('@space-shell/pages/sales/sales'))
const ContentConsume = lazyWithErrorBoundary(
  () => import('@space-shell/pages/contentConsume/server')
)
const ViewCertificate = lazyWithErrorBoundary(
  () => import('@space-shell/pages/certificatePreview/server')
)
const CertificateValidate = lazyWithErrorBoundary(
  () => import('@space-shell/pages/certificateValidate/server')
)
const NotFound = lazyWithErrorBoundary(() => import('@space-shell/pages/notFound'))
const AccessPlus = lazyWithErrorBoundary(() => import('@space-shell/pages/accessPlus'))

const Router = () => {
  useClearCache()

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Suspense fallback={<LoaderFull />}>
          <Routes>
            <Route path={RoutesPaths.HOME} element={<RouteGuard />}>
              <Route index element={<Home />} />

              <Route path={`${RoutesPaths.HOME}${RoutesPaths.PRODUCTS}`} element={<Products />} />

              <Route
                path={`${RoutesPaths.HOME}${RoutesPaths.GAMIFICATION}`}
                element={<Gamification />}
              />

              <Route path={`${RoutesPaths.HOME}${RoutesPaths.SALES}`} element={<SalesPage />} />

              <Route
                path={`${RoutesPaths.HOME}${RoutesPaths.CONTENT_CONSUME}`}
                element={<ContentConsume />}
              />

              <Route
                path={`${RoutesPaths.HOME}${RoutesPaths.COMMUNITY}/*`}
                element={<CommunityRouterServer />}
              />

              <Route
                path={`${RoutesPaths.HOME}${RoutesPaths.CERTIFICATE_PREVIEW}`}
                element={<ViewCertificate />}
              />

              <Route
                path={`${RoutesPaths.HOME}${RoutesPaths.CERTIFICATE_VALIDATE}`}
                element={<CertificateValidate />}
              />
              <Route
                path={`${RoutesPaths.HOME}${RoutesPaths.ACCESS_PLUS}`}
                element={<AccessPlus />}></Route>
            </Route>

            <Route path={`${BASE_PATH}/*`} element={<NotFound />} />
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  )
}

export default Router
